import type { ReactNode } from 'react';

export const symbol_split_scene_down: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M189.82-570q-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-180q0-24 18-42t42-18h520q24 0 42 18t18 42v180q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-180H220v180q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63ZM220-120q-24 0-42-18t-18-42v-270h-50q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-510 110-510h740q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-50v270q0 24-18 42t-42 18H220Zm0-660h520-520Z"
		/>
	</svg>
);
